import { css } from '@emotion/react';
import { useTranslation } from '@frontend/i18n';
import { classNames } from '@frontend/string';
import { theme } from '@frontend/theme';
import { Button, ButtonProps } from '@frontend/design-system';

export type PaymentMethodsGenericActionsProps = {
  primary: ButtonProps;
  secondary?: ButtonProps;
  shouldShow: boolean;
  shouldUsePadding?: boolean;
  className?: string;
};

const styles = {
  root: css`
    display: flex;
    align-items: center;
    justify-content: flex-end;
    column-gap: ${theme.spacing(2)};
  `,
  padding: css`
    padding: ${theme.spacing(2)};
  `,
};
export const PaymentMethodsGenericActions = ({
  primary,
  secondary,
  shouldShow,
  className,
  shouldUsePadding = true,
}: PaymentMethodsGenericActionsProps) => {
  const { t } = useTranslation();

  const { children: secondaryChildren, label: secondaryLabel, ...secondaryBtn } = secondary || {};

  const { children: primaryChildren, label: primaryLabel } = primary;

  if (!shouldShow) {
    return null;
  }

  return (
    <div
      className={classNames('payment-methods__generic-actions', className)}
      css={[styles.root, shouldUsePadding && styles.padding]}
    >
      {secondary && (
        <div>
          <Button {...secondary} variant={secondary.variant ?? 'secondary'} {...secondaryBtn}>
            {secondaryChildren || secondaryLabel || t('Cancel')}
          </Button>
        </div>
      )}

      <div>
        <Button {...primary} variant={primary.variant || 'primary'}>
          {primaryChildren || primaryLabel || t('Save')}
        </Button>
      </div>
    </div>
  );
};
